module.exports = __webpack_public_path__ + "img/gift_jbl_tt_de_1.668f0420.jpg";